export default __webpack_public_path__ + "static/media/figure_ojigi.6499555c.png";